import { SwalDialogService } from 'src/app/core/shared/services/swal-dialog.service';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { FormValidationService } from 'src/app/service/form-validation/form-validation.service';
import { StripeConfigInterface } from './stripe-config-interface';
import { StripeConfigService } from './stripe-config-service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'vex-stripe-config',
  standalone: true,
  imports: [
    MatIconModule,
    MatDividerModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './stripe-config.component.html',
  styleUrls: ['./stripe-config.component.scss']
})
export class StripeConfigComponent {
  form: FormGroup;
  stripeConfig: any;
  programConfigId: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<StripeConfigComponent>,
    private fb: FormBuilder,
    private formValidationService: FormValidationService,
    private stripeConfigService: StripeConfigService,
    private appSettingsService: AppSettingsService,
    private swalDialogService: SwalDialogService
  ) {
    this.stripeConfig = data?.testMethod;
    this.programConfigId = data?.programConfigId;
  }

  ngOnInit() {
    this.inIt();
  }
  inIt() {
    if (this.stripeConfig?.id) {
      this.form = this.fb.group({
        secretKey: [this.stripeConfig?.secretKey, Validators.required],
        publicKey: [this.stripeConfig?.publicKey, Validators.required]
      });
    } else {
      this.form = this.fb.group({
        secretKey: ['', Validators.required],
        publicKey: ['', Validators.required]
      });
    }
  }

  get isEdit(): boolean {
    return !!this.stripeConfig?.id;
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.formValidationService.validateAllFormFieldsWithoutScroll(this.form);
      return;
    }
    let form = this.form.value;

    let data: StripeConfigInterface = {
      secretKey: form.secretKey,
      publicKey: form.publicKey,
      programConfig: this.programConfigId.toString()
    };

    if (this.stripeConfig?.id) {
    } else {
      try {
        await firstValueFrom(this.stripeConfigService.createStripeConfig(data));
        await this.swalDialogService.showMessage({
          title: 'Stripe Configured Successfully!'
        });
        this.dialogRef.close(true);
      } catch (err) {
        this.stripeConfigService.handleError(err);
      }
    }
  }
}
